// ----------------------------------------------------------------------
// Global Dashboard Translations - Spanish
// ----------------------------------------------------------------------

export const globalDashboardEs = {
  global_dashboard: {
    // Page title
    page_title: 'Panel de Control',

    // Welcome messages by role
    welcome: {
      owner: 'Gestiona tu negocio desde aquí',
      ambassador: '¿Listo para promocionar eventos increíbles?',
      referral: 'Descubre nuevos eventos para compartir y ganar',
      waiter: 'Gestionemos esas mesas de manera eficiente',
      default: 'Tu panel está listo',
    },

    // Contextual info alerts
    context_info: {
      event_mode_title: 'Enfoque en Gestión de Eventos',
      event_mode_description: 'Estás en modo gestión de eventos. Cambia a modo restaurante o estudio de música en configuración si es necesario.',
      restaurant_mode_title: 'Enfoque en Gestión de Restaurante',
      restaurant_mode_description: 'Estás en modo gestión de restaurante. Cambia a modo eventos o estudio de música en configuración si es necesario.',
      music_studio_mode_title: 'Enfoque en Gestión de Estudio de Música',
      music_studio_mode_description: 'Estás en modo gestión de estudio de música. Cambia a modo eventos o restaurante en configuración si es necesario.',
    },

    // Dashboard modules
    modules: {
      events_management: 'Gestión de Eventos',
      events_description: 'Crea, gestiona y rastrea tus eventos',
      organizations: 'Organizaciones',
      organizations_description: 'Gestiona tus organizaciones y configuraciones',
      restaurants: 'Restaurantes',
      restaurants_description: 'Gestiona restaurantes y menús',
      music_studios: 'Estudios de Música',
      music_studios_description: 'Gestiona estudios de grabación, reservas y sesiones',
      network_team: 'Red y Equipo',
      network_team_description: 'Invita usuarios, gestiona el equipo y rastrea referencias',
      ambassador_events: 'Eventos de Embajador',
      ambassador_events_description: 'Ver y promocionar eventos como embajador',
      my_events: 'Mis Eventos',
      my_events_description: 'Rastrea tus eventos promocionados y ganancias',
      table_management: 'Gestión de Mesas',
      table_management_description: 'Gestiona mesas de restaurante y pedidos',
    },

    // Quick actions
    quick_actions: {
      title: 'Acciones Rápidas',
      create_event: 'Crear Evento',
      create_organization: 'Crear Organización',
      invite_team: 'Invitar Equipo',
      search_events: 'Buscar Eventos',
    },

    // Available modules section
    available_modules: 'Módulos Disponibles',

    // Buttons
    buttons: {
      open: 'Abrir',
      manage: 'Gestionar',
      copy_link: 'Copiar Enlace',
      share: 'Compartir',
      create_event: 'Crear Evento',
      create_event_org: 'Crear Org. de Evento',
      create_studio: 'Crear Estudio',
    },

    // Labels
    labels: {
      new: 'Nuevo',
      event_org: 'Org. Evento',
      studio: 'Estudio',
    },

    // Enhanced events module
    events_module: {
      title: 'Gestión de Eventos',
      recent_events: 'eventos recientes',
      click_to_manage: 'Haz clic para gestionar todos',
      no_recent_events: 'Sin eventos recientes',
      click_to_create: 'Haz clic para crear tu primer evento',
      create_first_event: 'Crea tu primer evento para comenzar',
      more_events: 'más eventos',
    },

    // Event organizations module
    event_orgs_module: {
      title: 'Organizaciones de Eventos',
      recent_organizations: 'organizaciones recientes',
      no_organizations: 'Aún no hay organizaciones de eventos',
      create_first_org: 'Crea tu primera organización de eventos',
      followers: 'seguidores',
    },

    // Music studios module
    music_studios_module: {
      title: 'Estudios de Música',
      recent_studios: 'estudios recientes',
      no_studios: 'Aún no hay estudios de música',
      create_first_studio: 'Crea tu primer estudio de música',
      services: 'servicios',
    },

    // Invitation card
    invitation_card: {
      title: 'Invitar a la Red',
      description: 'Comparte tu enlace de invitación',
      your_link: 'Tu enlace de invitación:',
      link_copied: '¡Enlace de invitación copiado al portapapeles!',
      link_copy_failed: 'Error al copiar el enlace',
      share_title: 'Únete a Mi Red',
      share_text: '¡Únete a mi red y descubre eventos increíbles!',
    },

    // Contacts card
    contacts_card: {
      title: 'Mis Contactos',
      description: 'Gestiona tus contactos',
      access_list: 'Accede a tu lista de contactos',
      add_new: 'Agregar nuevos contactos',
      send_messages: 'Enviar correos y mensajes',
    },

    // Event status chips
    event_status: {
      upcoming: 'próximo',
      ongoing: 'en curso',
      past: 'pasado',
    },

    // Mode chips
    mode: {
      event: 'Modo Evento',
      music_studio: 'Modo Estudio de Música',
      restaurant: 'Modo Restaurante',
    },

    // Footer
    footer: {
      help_text: '¿Necesitas ayuda? Consulta nuestra documentación o contacta al soporte.',
    },
  },
};

export default globalDashboardEs;
